import $ from 'jquery';
import starterkit from 'images/products/starter-kit@3x.png';
import podpacks from 'images/products/pod-packs@3x.png';
import basickit from 'images/products/basic-kit@3x.png';
import usbcharger from 'images/products/usb-charger@3x.png';

import { toggleScrollLock } from 'common/utils';
import MobileMenu from 'apps/application/mobile-menu';
import ShopPanel from 'apps/application/shop-panel';

const SIDE_NAV_CLASS = 'header__sidenav';
export const HEADER_OVERLAY_CLASS = 'header__overlay';
export const HEADER_OVERLAY_VISIBLE_CLASS = 'header__overlay--visible';
export const HEADER_SHOP_CONTAINER = 'header__shop-link-hover-container';
export const HEADER_SHOP_CONTAINER_VISIBLE_CLASS =
  'header__shop-link-hover-container--visible';
const ABOUT_US_SHOP_CONTAINER = 'header__about-us-link-hover-container';
const ABOUT_US_SHOP_CONTAINER_VISIBLE_CLASS =
  'header__about-us-link-hover-container--visible';
const HIDE_HEADER_DELAY = 200;
const OVERLAY_SHOP = 'overlay__shop';
const OVERLAY_ABOUT_US = 'overlay__about-us';

let bodyEl;
let hamburgerIcon;
let hamburgerMenu;
let hamburgerMenuAlt;
let headerOverlay;
let headerSideNav;
let isOpen;
let shopContainer;
let aboutUsContainer;
let shopLink;
let aboutUsLink;
let timer;
let aboutTimer;
let activeOverlay = null;

export const getState = function() {
  return isOpen;
};

export const toggleButtonVisibility = function(el = hamburgerMenu) {
  el && el.classList.toggle('header__hamburger-menu--hidden');
};

export const showShopContainer = function(el = shopContainer) {
  el && el.classList.add(HEADER_SHOP_CONTAINER_VISIBLE_CLASS);
};

export const hideShopContainer = function(el = shopContainer) {
  el && el.classList.remove(HEADER_SHOP_CONTAINER_VISIBLE_CLASS);
};

export const showAboutUsContainer = function(el = aboutUsContainer) {
  el && el.classList.add(ABOUT_US_SHOP_CONTAINER_VISIBLE_CLASS);
};

export const hideAboutUsContainer = function(el = aboutUsContainer) {
  el && el.classList.remove(ABOUT_US_SHOP_CONTAINER_VISIBLE_CLASS);
};

export const showHeaderOverlay = function() {
  headerOverlay && headerOverlay.classList.add(HEADER_OVERLAY_VISIBLE_CLASS);
};

export const hideHeaderOverlay = function() {
  headerOverlay && headerOverlay.classList.remove(HEADER_OVERLAY_VISIBLE_CLASS);
};

export const toggleVisibility = function() {
  isOpen = !isOpen;

  toggleScrollLock(`.${SIDE_NAV_CLASS}`, isOpen);

  if (isOpen) {
    showHeaderOverlay();
  } else {
    hideHeaderOverlay();
  }
  hamburgerIcon && hamburgerIcon.classList.toggle('hamburger-icon--open');
  headerSideNav && headerSideNav.classList.toggle('hide');
};

export const attachListeners = ({
  hamburgerMenu,
  hamburgerMenuAlt,
  hideHeaderOverlay,
  hideShopContainer,
  hideAboutUsContainer,
  setTimeout,
  shopLink,
  aboutUsLink,
  showHeaderOverlay,
  showShopContainer,
  showAboutUsContainer,
  toggleVisibility,
}) => {
  hamburgerMenu &&
    hamburgerMenu.addEventListener('click', e => {
      toggleVisibility();
    });

  const handleMouseEnterEvent = function(link, callbackFn) {
    if (link) {
      link.addEventListener('mouseenter', callbackFn);
    }
  };

  const handleMouseLeaveEvent = function(link, callbackFn) {
    if (link) {
      link.addEventListener('mouseleave', callbackFn);
    }
  };

  const handleClickEvent = function(link, callbackFn) {
    if (link) {
      link.addEventListener('click', callbackFn);
    }
  };

  handleClickEvent(shopLink, e => {
    activeOverlay = OVERLAY_SHOP;
    clearTimeout(timer);
    showHeaderOverlay();
    showShopContainer();
  });

  handleClickEvent(aboutUsLink, e => {
    activeOverlay = OVERLAY_ABOUT_US;
    clearTimeout(aboutTimer);
    showHeaderOverlay();
    showAboutUsContainer();
  });

  handleMouseEnterEvent(shopLink, e => {
    activeOverlay = OVERLAY_SHOP;
    clearTimeout(timer);
    showHeaderOverlay();
    showShopContainer();
  });

  handleMouseEnterEvent(aboutUsLink, e => {
    activeOverlay = OVERLAY_ABOUT_US;
    clearTimeout(aboutTimer);
    showHeaderOverlay();
    showAboutUsContainer();
  });

  handleMouseLeaveEvent(shopLink, e => {
    timer = setTimeout(() => {
      if (activeOverlay == OVERLAY_SHOP) {
        hideHeaderOverlay();
      }
      hideShopContainer();
    }, HIDE_HEADER_DELAY);
  });

  handleMouseLeaveEvent(aboutUsLink, e => {
    aboutTimer = setTimeout(() => {
      if (activeOverlay == OVERLAY_ABOUT_US) {
        hideHeaderOverlay();
      }
      hideAboutUsContainer();
    }, HIDE_HEADER_DELAY);
  });

  hamburgerMenuAlt = new MobileMenu('.header__sidenav-alt', {
    textLinkClasses: 'header__sidenav-text-link',
    toggleSidebar: toggleVisibility,
  });

  new ShopPanel(
    document.getElementById('js-home-shop-panel-toggle'),
    document.getElementById('js-home-shop-panel-items')
  );
};

if (!global.__isHeaderInitialized) {
  global.__isHeaderInitialized = true;

  bodyEl = document.body;
  hamburgerIcon = document.getElementsByClassName('hamburger-icon')[0];
  hamburgerMenu = document.getElementsByClassName('header__hamburger-menu')[0];
  headerOverlay = document.getElementsByClassName(HEADER_OVERLAY_CLASS)[0];
  headerSideNav = document.getElementsByClassName(SIDE_NAV_CLASS)[0];
  isOpen = false;
  shopContainer = document.getElementsByClassName(HEADER_SHOP_CONTAINER)[0];
  aboutUsContainer = document.getElementsByClassName(
    ABOUT_US_SHOP_CONTAINER
  )[0];
  shopLink = document.getElementsByClassName(
    'header__shop header__navbar-item'
  )[0];
  aboutUsLink = document.getElementsByClassName(
    'header__about-us header__navbar-item'
  )[0];

  const listenerParams = {
    hamburgerMenu,
    hamburgerMenuAlt,
    hideHeaderOverlay,
    hideShopContainer,
    hideAboutUsContainer,
    setTimeout,
    shopLink,
    aboutUsLink,
    showHeaderOverlay,
    showShopContainer,
    showAboutUsContainer,
    toggleVisibility,
  };

  attachListeners(listenerParams);
}



// WEBPACK FOOTER //
// ./app/javascript/apps/application/header.js